import GoogleMapScript from '@utils/GoogleMapScript';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BookAnAppointmentForm from './BookAnAppointmentForm';
const BookAnAppointmentPage = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "client-service account-appointments", id: "bookanappointement" },
        React.createElement(GoogleMapScript, null,
            React.createElement(BookAnAppointmentForm, Object.assign({ type: "page" }, props)))));
};
export default BookAnAppointmentPage;
